import React, { useState, useEffect } from 'react';
import useTableFijo from '../useTableFijo';
import { AgregarOrdenPagoDevolver } from './modalAgregarOrdenPagoDevolver';

import { Mensaje } from '../mensajes2';
import { Dimmer } from '../spinner';
import CatalogoOrdenPago3 from '../../catalogos/catalogoOrdenPago3';

function TablaOrdenesdePagosDevolver(props) {
    const headCells = [
        { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'N° Documento', textAlign: 'center' },
        { id: '11', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Concepto', textAlign: 'center' },
        { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Motivo', textAlign: 'center' },
        { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Proveedor', textAlign: 'center' },
        { id: '14', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Opciones', textAlign: 'center' },
    ];
    
    const [mostrar5, setMostrar5] = useState(false);
    const [mostrarCatalogo, setMostrarCatalogo] = useState(false);
    const [activate, setActivate] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const [mensaje, setMensaje] = useState({ 
        mostrar: false, 
        titulo: '', 
        texto: '', 
        icono: '' 
    });

    const {
        TblContainer,
        TblHead,
        recordsAfterPagingAndSorting
    } = useTableFijo(records, headCells, filterFn, 220);
    
    // Cerrar modal de agregar (si aún lo usas)
    const cerrarModalActualizar = () => {
        setMostrar5(false);
    };
    
    // Cerrar catálogo
    const cerrarCatalogo = () => {
        setMostrarCatalogo(false);
    };
    
    // Función para abrir el catálogo
    const abrirCatalogo = (event) => {
        event.preventDefault();
        //setMostrarCatalogo(true);
        setMostrar5(true);
        setOperacion(1);
    };
    
    // Verificar si un documento ya existe en la tabla
    const verificarExistencia = (idordenpago, array) => {
        return array.some(item => item.idordenpago === idordenpago);
    };
    
    // Manejar la selección de documentos desde el catálogo
    const handleAceptarCatalogo = (datosSeleccionados) => {
        setMostrarCatalogo(false);
        
        if (!datosSeleccionados || datosSeleccionados.length === 0) {
            setMensaje({ 
                mostrar: true, 
                titulo: 'Notificación', 
                texto: 'No se seleccionaron documentos.', 
                icono: 'informacion' 
            });
            return;
        }
        
        let data = [...records];
        let nuevosRegistros = [];
        let duplicados = [];
        
        // Procesar cada documento seleccionado del catálogo
        datosSeleccionados.forEach(item => {
            const existe = verificarExistencia(item.idordenpago, data);
            
            if (!existe) {
                // Crear objeto con la estructura requerida
                const nuevoRegistro = {
                    idcompromiso: item.idcompromiso || '',
                    concepto: item.concepto || '',
                    fecha: item.fecha || new Date(),
                    tipo: props.camptab || 'Normal',
                    idordencompra: item.idordencompra || '',
                    idordenpago: item.idordenpago || '',
                    numordenpago: item.numordenpago || item.idordenpago, // Usar numordenpago si existe
                    idproveedor: item.idproveedor || '',
                    proveedor: item.proveedor || item.razonsocial || '',
                    motivo: props.motivoDefault || 'DEVOLUCIÓN', // Motivo configurable
                    razonsocial: item.proveedor || item.razonsocial || '',
                    ubicacion: props.ubicacion || item.ubicacion || '',
                    monto: item.monto || 0, // Si el catálogo incluye monto
                    estado: 'PENDIENTE',
                    usuario: localStorage.getItem('usuario') || 'SISTEMA',
                    fecha_registro: new Date().toISOString().split('T')[0]
                };
                
                nuevosRegistros.push(nuevoRegistro);
                data.push(nuevoRegistro);
            } else {
                duplicados.push(item.numordenpago || item.idordenpago);
            }
        });
        
        // Actualizar el estado local
        setRecords(data);
        
        // Notificar al componente padre si existe la función
        if (props.data && typeof props.data === 'function') {
            props.data(data);
        }
        
        // Mostrar mensaje apropiado
        if (nuevosRegistros.length === 0 && duplicados.length > 0) {
            setMensaje({ 
                mostrar: true, 
                titulo: 'Información', 
                texto: `Todos los documentos seleccionados ya existen en la lista.`, 
                icono: 'informacion' 
            });
        } else if (duplicados.length > 0) {
            setMensaje({ 
                mostrar: true, 
                titulo: 'Información', 
                texto: `${nuevosRegistros.length} documento(s) agregado(s). ${duplicados.length} documento(s) ya existían.`, 
                icono: 'informacion' 
            });
        } else {
            setMensaje({ 
                mostrar: true, 
                titulo: 'Éxito', 
                texto: `${nuevosRegistros.length} documento(s) agregado(s) correctamente.`, 
                icono: 'exito' 
            });
        }
    };
    
    // Función para manejar datos del modal antiguo (si se mantiene)
    const handleAceptarDatos = (datos) => {
        setMostrar5(false);
        if (datos && datos.length > 0) {
            let data = [...records];
            datos.forEach(item => {
                const existe = verificarExistencia(item.idordenpago, data);
                if (!existe) {
                    data.push({
                        idcompromiso: item.idcompromiso || item.numordenpago,
                        concepto: item.concepto,
                        fecha: item.fecha,
                        tipo: item.tipo || props.camptab || 'Normal',
                        idordencompra: item.idordencompra,
                        idordenpago: item.idordenpago,
                        idproveedor: item.idproveedor,
                        proveedor: item.razonsocial,
                        motivo: item.motivo || props.motivoDefault || 'DEVOLUCIÓN',
                        razonsocial: item.razonsocial,
                        ubicacion: item.ubicacion || props.ubicacion,
                    });
                }
            });
            setRecords(data);
            if (props.data) {
                props.data(data);
            }
        }
    };
    
    // Inicializar con datos proporcionados por props
    useEffect(() => {
        if (props.datarecords && props.datarecords.length > 0) {
            const datosTransformados = props.datarecords.map(item => ({
                idcompromiso: item.numordenpago || item.idcompromiso || '',
                concepto: item.concepto || '',
                fecha: item.fecha || new Date(),
                tipo: item.tipo || props.camptab || 'Normal',
                idordencompra: item.idordencompra || '',
                idordenpago: item.idordenpago || '',
                numordenpago: item.numordenpago || item.idordenpago,
                idproveedor: item.idproveedor || '',
                proveedor: item.proveedor || item.razonsocial || '',
                motivo: item.motivo || props.motivoDefault || 'DEVOLUCIÓN',
                razonsocial: item.razonsocial || '',
                ubicacion: item.ubicacion || props.ubicacion || '',
                monto: item.monto || 0,
                estado: item.estado || 'PENDIENTE'
            }));
            setRecords(datosTransformados);
        } else {
            setRecords([]);
        }
    }, [props.datarecords, props.camptab, props.ubicacion, props.motivoDefault]);
    
    // Eliminar un registro de la tabla
    const eliminarSolicitud = (item) => (e) => {
        e.preventDefault();
        const datosFiltrados = records.filter(record => 
            record.idordenpago !== item.idordenpago
        );
        setRecords(datosFiltrados);
        
        if (props.data && typeof props.data === 'function') {
            props.data(datosFiltrados);
        }
        
        setMensaje({ 
            mostrar: true, 
            titulo: 'Éxito', 
            texto: 'Documento eliminado correctamente.', 
            icono: 'exito' 
        });
    };
    
    // Función para buscar en la tabla
    const handleSearch = (e) => {
        const { value } = e.target;
        setFilterFn({
            fn: items => {
                if (value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        const searchValue = value.toLowerCase();
                        return (
                            (x.idcompromiso && x.idcompromiso.toString().toLowerCase().includes(searchValue)) ||
                            (x.concepto && x.concepto.toLowerCase().includes(searchValue)) ||
                            (x.proveedor && x.proveedor.toLowerCase().includes(searchValue)) ||
                            (x.motivo && x.motivo.toLowerCase().includes(searchValue)) ||
                            (x.numordenpago && x.numordenpago.toString().toLowerCase().includes(searchValue))
                        );
                    });
                }
            }
        });
    };
    
    // Calcular total si hay montos
    const calcularTotal = () => {
        return records.reduce((total, item) => {
            return total + (parseFloat(item.monto) || 0);
        }, 0);
    };

    return (
        <div className='col-md-12 row mx-auto p-0 m-0'>
            {/* Catálogo de órdenes de pago */}
            <CatalogoOrdenPago3
                show={mostrarCatalogo}
                onHideAceptaCatalogo={handleAceptarCatalogo}
                onHideCancela={cerrarCatalogo}
                        ubicacion={44}
            />
            
            {/* Modal antiguo (opcional) */}
            <AgregarOrdenPagoDevolver
                show={mostrar5}
                operacion={operacion}
                onDatos={handleAceptarDatos}
                onHideCancela={cerrarModalActualizar}
                idval={records}
                esaumento={props.camptab === 'Aumento'}
            />
            
            {/* Mensajes */}
            <Mensaje 
                mensaje={mensaje}
                onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })}
            />
            
            {/* Spinner */}
            <Dimmer active={activate} inverted />
            
            {/* Controles superiores */}
           
             
                   {/*  <div className="input-group input-group-sm col-md-6">
                        <span className="input-group-text">
                            <i className="fas fa-search"></i>
                        </span>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Buscar por documento, concepto o proveedor..."
                            onChange={handleSearch}
                        />
                    </div>
                */}

                <div className="col-md-6 mb-1 ml-0">
                   
                </div>
                
              
        
            
            {/* Tabla */}
            <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                <TblContainer>
                    <TblHead />
                    <tbody>
                        {records.length === 0 ? (
                            <tr>
                                <td colSpan={headCells.length} className="text-center py-4">
                                    <div className="text-muted">
                                        <i className="fas fa-inbox fa-2x mb-2"></i>
                                        <p>No hay documentos agregados</p>
                                        <small>Haz clic en "INCLUIR" para agregar documentos desde el catálogo</small>
                                    </div>
                                </td>
                            </tr>
                        ) : (
                            recordsAfterPagingAndSorting().map((item, index) => (
                                <tr 
                                    key={`${item.idordenpago}-${index}`} 
                                    className="table-bordered align-middle"
                                    style={{ 
                                        background: index % 2 === 0 ? '#f8f9fa' : 'white',
                                        transition: 'background-color 0.3s'
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#e9f7fe'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#f8f9fa' : 'white'}
                                >
                                    <td style={{ fontSize: "12px", textAlign: "center", padding: "8px" }}>
                                        <strong>{item.numordenpago || item.idcompromiso}</strong>
                                    </td>
                                    <td style={{ fontSize: "12px", padding: "8px" }}>
                                        <div style={{ maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                            {item.concepto}
                                        </div>
                                    </td>
                                    <td className='text-uppercase' style={{ fontSize: "12px", textAlign: "center", padding: "8px" }}>
                                        <span className={`badge ${item.motivo === 'PAGO' ? 'bg-success' : 'bg-warning'}`}>
                                            {item.motivo}
                                        </span>
                                    </td>
                                    <td style={{ fontSize: "12px", padding: "8px" }}>
                                        <div style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                            {item.proveedor || item.razonsocial}
                                        </div>
                                    </td>
                                    <td style={{ fontSize: "12px", textAlign: "center", padding: "8px" }}>
                                        <button 
                                            onClick={eliminarSolicitud(item)} 
                                            disabled={props.operacion === 4 || props.operacion === 2}
                                            className="btn btn-danger btn-sm rounded-circle"
                                            title="Eliminar documento"
                                        >
                                            <i className="fa fa-trash-alt"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </TblContainer>
            </div>
            
            {/* Footer con botón de incluir */}
            <div className="row mt-3">
                <div className="col-12 d-flex justify-content-between align-items-center">
                  
                    <div>
                        <button 
                            onClick={abrirCatalogo}
                            disabled={props.operacion === 4 || props.operacion === 2}
                            className="btn btn-primary btn-sm"
                            style={{ minWidth: '120px' }}
                        >
                            <i className="fas fa-plus me-1"></i>
                            INCLUIR
                        </button>
                    </div>
                </div>
            </div>
            
          
        </div>
    );
}



export default TablaOrdenesdePagosDevolver;